// Favre — karuzele kolekcji na stronie głównej: strzałki, przeciąganie myszą, stan strzałek.
(() => {
  document.querySelectorAll('[data-fg-karuzela]').forEach((box) => {
    const track = box.querySelector('[data-fg-track]');
    const prev = box.querySelector('[data-fg-prev]');
    const next = box.querySelector('[data-fg-next]');
    if (!track) return;

    // Płynny przejazd (2026-10-29): własna animacja scrollLeft z wygładzeniem zamiast
    // natywnego smooth + snap, który szarpał na końcu. Snap wyłączony na czas ruchu.
    const bezRuchu = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let anim = 0;
    const jedz = (cel, ms = 720, krzywa = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)) => {
      cancelAnimationFrame(anim);
      const max = track.scrollWidth - track.clientWidth;
      cel = Math.max(0, Math.min(max, cel));
      if (bezRuchu) { track.scrollLeft = cel; return; }
      const start = track.scrollLeft;
      const droga = cel - start;
      if (Math.abs(droga) < 1) return;
      const t0 = performance.now();
      track.style.scrollSnapType = 'none';
      const krok = (now) => {
        const t = Math.min(1, (now - t0) / ms);
        track.scrollLeft = start + droga * krzywa(t);
        if (t < 1) anim = requestAnimationFrame(krok);
        else track.style.scrollSnapType = '';
      };
      anim = requestAnimationFrame(krok);
    };
    const wyhamuj = (t) => 1 - Math.pow(1 - t, 4);
    // pozycje, w których zatrzymuje się snap (lewa krawędź kafla - scroll-padding);
    // cele animacji = dokładnie te punkty, więc po przywróceniu snapu nic nie przeskakuje
    const punkty = () => {
      const tr = track.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      const max = track.scrollWidth - track.clientWidth;
      return [...track.querySelectorAll('.fg__item')].map((it) =>
        Math.max(0, Math.min(max, Math.round(track.scrollLeft + it.getBoundingClientRect().left - tr.left - pad)))
      );
    };
    const najblizszy = (x) => punkty().reduce((a, b) => (Math.abs(b - x) < Math.abs(a - x) ? b : a), 0);
    const szerKafla = () => {
      const item = track.querySelector('.fg__item');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const krok = () => {
      const item = track.querySelector('.fg__item');
      if (!item) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      // przewijamy o tyle pełnych kafli, ile mieści się na ekranie
      const szer = item.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((track.clientWidth + gap) / szer)) * szer;
    };

    const stan = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };

    // cel liczony od pozycji wyrównanej do kafla - kolejne szybkie kliki nie gubią rytmu
    const celStrzalki = (kier) => {
      return najblizszy(najblizszy(track.scrollLeft) + kier * krok());
    };
    prev?.addEventListener('click', () => jedz(celStrzalki(-1)));
    next?.addEventListener('click', () => jedz(celStrzalki(1)));

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(stan);
    }, { passive: true });
    window.addEventListener('resize', stan, { passive: true });
    stan();

    // klawiatura
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next?.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev?.click(); }
    });

    // przeciąganie myszą (dotyk przewija natywnie)
    let startX = 0, startLeft = 0, wcisniety = false, przeciagniete = false;
    let ostX = 0, ostT = 0, predkosc = 0;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      cancelAnimationFrame(anim);
      wcisniety = true;
      przeciagniete = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
      ostX = e.clientX;
      ostT = performance.now();
      predkosc = 0;
    });
    window.addEventListener('pointermove', (e) => {
      if (!wcisniety) return;
      const dx = e.clientX - startX;
      if (!przeciagniete && Math.abs(dx) > 5) {
        przeciagniete = true;
        track.classList.add('is-dragging');
      }
      if (przeciagniete) track.scrollLeft = startLeft - dx;
      // prędkość ruchu myszy (px/ms, wygładzona) - do rozpędu po puszczeniu
      const now = performance.now();
      const dt = now - ostT;
      if (dt > 0) predkosc = 0.8 * ((e.clientX - ostX) / dt) + 0.2 * predkosc;
      ostX = e.clientX;
      ostT = now;
    });
    window.addEventListener('pointerup', () => {
      if (!wcisniety) return;
      wcisniety = false;
      if (!przeciagniete) return;
      track.classList.remove('is-dragging');
      // rozpęd: karuzela jedzie dalej w stronę ruchu i miękko wyhamowuje na najbliższym kaflu
      const swiezy = performance.now() - ostT < 80 ? predkosc : 0;
      const rzut = track.scrollLeft - swiezy * 260;
      jedz(najblizszy(rzut), 560 + Math.min(320, Math.abs(swiezy) * 160), wyhamuj);
    });
    // kliknięcie zaraz po przeciągnięciu nie otwiera produktu
    track.addEventListener('click', (e) => {
      if (przeciagniete) {
        e.preventDefault();
        e.stopPropagation();
        przeciagniete = false;
      }
    }, true);
  });
})();
